"use strict";

import Vue from 'vue'
import allBetMixin from '@/vue/mixins/allBet'

Vue.component('handicap',{
  name:'handicap',
  template: `
    <span class="txt">
      <template v-if="event.od">
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType][matchId]">
              <template v-if="event.od[plyType][betType][matchId].fav == favTeam">
                <template v-if="(betType==1 || betType==8) && hdp!='0'">
                  -{{ hdp }}
                </template>
                <template v-else>
                  {{ hdp }}
                </template>
              </template>
              <template v-else>
                <template v-if="(betType==1 || betType==8) && hdp!='0'">
                  +{{ hdp }}
                </template>
                <template v-else-if="(betType==1 || betType==8)" >
                  {{ hdp }}
                </template>
              </template>
            </template>
          </template>
        </template>
      </template>
    </span>
  `,
  props: {
    event: null,
    plyType: null,
    betType: null,
    match: null,
    favTeam: {
      type: String,
      default: 'a', //a or b
    },
    showType: null,
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        //cater for 3 match only
        if(this.match == 0 || this.match == 'a')
          this.matchId = 'a'
        else if(this.match == 1 || this.match == 'b')
          this.matchId = 'b'
        else if(this.match == 2 || this.match == 'c')
          this.matchId = 'c'
        else
          this.matchId = 'd'
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    hdp : (val) => {
      var split = val.event.od[val.plyType][val.betType][val.matchId].hdp.split('/',2)
      var returnValue = ''
      if(split.length > 1) {
        return split[0] + '/' + split[1]
      } else {
        return split[0]
      }
    }
  },
  data() {
    return {
      matchId: null,
    }
  },
  method:{
  },
})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/handicap.js